import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";
import {StringBuilder} from "../../AppUtils.js";

export const createDeliveryProvider = async deliveryProvider => {
    const createdDeliveryProvider = await HttpClient.post(`/admin/api/deliveryProviders`, deliveryProvider);

    if (createdDeliveryProvider.error) {
        message.error(
            new StringBuilder("שגיאה בעת יצירת ספק שילוח").append(`(${createdDeliveryProvider.error})`).toString()
        );
    } else {
        message.success("ספק השילוח נוצר בהצלחה");
    }

    return createdDeliveryProvider;
};

export const updateDeliveryProvider = async (deliveryProviderId, deliveryProviderData) => {
    const changeStatusRes = await HttpClient.put(
        `/admin/api/deliveryProviders/${deliveryProviderId}`,
        deliveryProviderData
    );

    if (changeStatusRes.error) {
        message.error(
            new StringBuilder("שגיאה בעת שינוי סטאטוס ההזמנה").append(`(${changeStatusRes.error})`).toString()
        );
    } else {
        message.success("סטאטוס ההזמנה שונה בהצלחה");
    }
};

export const addDeliveryProviderDriver = async (deliveryProvider, driverInput) => {
    const createdDeliveryProvider = await HttpClient.post(
        `/admin/api/deliveryProviders/drivers/${deliveryProvider}`,
        driverInput
    );

    if (createdDeliveryProvider.error) {
        message.error(new StringBuilder("שגיאה בעת יצירת נהג").append(`(${createdDeliveryProvider.error})`).toString());
    } else {
        message.success("נהג נוצר בהצלחה");
    }

    return createdDeliveryProvider;
};

export const updateDeliveryProviderDriver = async (deliveryProvider, driverId, driverInput) => {
    const createdDeliveryProvider = await HttpClient.put(
        `/admin/api/deliveryProviders/${deliveryProvider}/drivers/${driverId}`,
        driverInput
    );

    if (createdDeliveryProvider.error) {
        message.error(new StringBuilder("שגיאה בעת עדכון נהג").append(`(${createdDeliveryProvider.error})`).toString());
    } else {
        message.success("פרטי נהג עודכנו בהצלחה");
    }

    return createdDeliveryProvider;
};
